import BaseButton from "./BaseButton.vue";

export type { BaseButtonProps, ButtonSize } from "./BaseButton.vue";
export default BaseButton;
